// Header interactions — mega menu is CSS hover on desktop; this wires the mobile drawer + accordion
document.addEventListener('click',function(e){
  var b=e.target.closest('.burger');
  if(b){
    var nav=document.querySelector('.hdr-nav');
    var open=nav.classList.toggle('open');
    nav.style.cssText = open ? 'display:flex;flex-direction:column;position:absolute;top:114px;left:0;right:0;background:#FFFFFF;padding:0 var(--gut);border-bottom:1px solid var(--line-soft);z-index:60;max-height:calc(100vh - 114px);overflow-y:auto' : '';
    return;
  }
  var toggle=e.target.closest('.hdr-nav.open .has-mega > a');
  if(toggle){
    e.preventDefault();
    toggle.closest('.has-mega').classList.toggle('expanded');
  }
});
